import { render, staticRenderFns } from "./Abstract.vue?vue&type=template&id=6f6b97ad&scoped=true&"
import script from "./Abstract.vue?vue&type=script&lang=js&"
export * from "./Abstract.vue?vue&type=script&lang=js&"
import style0 from "./Abstract.vue?vue&type=style&index=0&id=6f6b97ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b97ad",
  null
  
)

export default component.exports